import { CloudFilled } from '@ant-design/icons';
import type { FeatureConfig } from '@skynet/feature-config';
import { RETAINERS_ARCHIVE_ROUTE_PATH, RETAINERS_ARCHIVE_URL } from './routes';

/**
 * The Retainers domain's archive section. Unlike the Admin feature configs, `nav.url`
 * lives under `/retainers` rather than `/admin`, and the section takes no entity id,
 * so the app registers the route without `withRedirectDefaults`.
 */
export const retainersArchiveConfig = {
  domain: 'Retainers',
  section: 'archive',
  route: {
    path: RETAINERS_ARCHIVE_ROUTE_PATH,
    load: async () => ({ default: (await import('./ArchivedProjectsPage')).ArchivedProjectsPage }),
  },
  nav: {
    key: 'retainers.archive',
    label: 'Archive',
    icon: <CloudFilled />,
    url: RETAINERS_ARCHIVE_URL,
  },
  header: { label: 'Archive' },
  cerbosAction: 'read:retainers:archive',
  needsEntityId: false,
} as const satisfies FeatureConfig;
